import React, { useCallback } from 'react';

import { Image } from '@core/js/components/common/Image';
import { WebContent } from '@core/js/components/system/WebContent';

import { useDeltaChanged } from '@core/js/components/common/Slider/withSwipe/hooks';
import * as constants from '@core/js/components/main/Banner/components/Slide/constants';
import * as hooks from '@core/js/components/main/Banner/components/Slide/hooks';
import { IBannerSlide } from '@core/js/components/main/Banner/types';

import style from './Slide.scss';

interface ISlideProps {
    slide: IBannerSlide
    dataAttr: Record<string, number>
}

/* Sun: added dataAttr */
export const Slide: React.FC<ISlideProps> = ({ slide, dataAttr }) => {
    const isDeltaChanged = useDeltaChanged();
    const runSlideAction = hooks.useRunSlideAction();
    const { slideContentType, slideContentImageURL, slideAction, slideContentWCId, slideContentBackupImageURL } = slide;

    const handleSlideClick = useCallback((event: React.SyntheticEvent<HTMLElement>) => {
        if (slide.slideAction !== constants.SLIDE_ACTION_TYPES.none) {
            event.stopPropagation();
            event.preventDefault();
        }

        !isDeltaChanged && runSlideAction(slide);
    }, [slide, isDeltaChanged, runSlideAction]);

    return (
        <div className={style.slide} tabIndex={0} {...dataAttr}>
            {slideContentType === constants.SLIDE_CONTENT_TYPES.image ? (
                <Image
                    alt={'slide-image'}
                    onClickCapture={handleSlideClick}
                    src={[slideContentImageURL, slideContentBackupImageURL]}
                    className={`${style.image} ${slideAction !== constants.SLIDE_ACTION_TYPES.none ? style.link : ''}`}
                />
            ) : (
                <div>
                    <WebContent className={style.wc} id={slideContentWCId} />
                </div>
            )}
        </div>
    );
};
